import React from 'react';
import { IconLeft1 } from '@99designs/icons';
import { SubtleLink, SubtleLinkProps } from './SubtleLink';

export function BackLink({ children, ...props }: SubtleLinkProps) {
    return (
        <SubtleLink {...props}>
            <IconLeft1 />
            {children}
        </SubtleLink>
    );
}
